import { Divider, Grid, MenuItem, Typography } from '@mui/material';
import { ValidationErrors, Validator } from 'fluentvalidation-ts';
import React, { useEffect } from 'react';
import { DeployDetailsForm } from '../../Tenant/Model/TenantModels';
import { CardWrapper } from '../../Common/CommonComponents';
import { CustomSelect } from '../../../../Common/Components/Controls/InputControls';

class FormValidator extends Validator<DeployDetailsForm> {
  constructor() {
    super();
    this.ruleFor('Branch').notEmpty().withMessage('Branch cannot be empty');
  }
}

const DeploymentForm = (props: {
  branches: string[];
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  deployDetailsForm: DeployDetailsForm;
  errors: ValidationErrors<DeployDetailsForm>;
  setErrors: React.Dispatch<
    React.SetStateAction<ValidationErrors<DeployDetailsForm>>
  >;
}) => {
  const { branches, handleChange, deployDetailsForm, errors, setErrors } =
    props;

  const formValidator = new FormValidator();

  const validate = () => {
    const formErrors = formValidator.validate(deployDetailsForm);
    setErrors(formErrors);
  };

  useEffect(() => {
    validate();
  }, []);

  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <CardWrapper>
            <Typography variant="h6" sx={{ mb: 2, fontWeight: 500 }}>
              Platform
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} sm={6}>
                <Typography variant="body1">Platform Branch</Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <CustomSelect
                  error={!!errors.Branch}
                  helperText={errors.Branch}
                  value={deployDetailsForm.Branch}
                  placeholder="Platform Branch"
                  name="Branch"
                  onChange={handleChange}
                  onBlur={validate}
                >
                  {branches.map((branchname) => {
                    return (
                      <MenuItem key={branchname} value={branchname}>
                        {branchname.replace('refs/heads/', '')}
                      </MenuItem>
                    );
                  })}
                </CustomSelect>
              </Grid>
            </Grid>
          </CardWrapper>
        </Grid>
      </Grid>
    </>
  );
};

export default DeploymentForm;
